<div class="modal-header">
    <h4>{{localize(langSection.InvalidImportEntriesModal, langText.InvalidImportEntriesHeader)}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
</div>
<div class="modal-body">
    <div class="instructions">
        <p>
            {{localize(langSection.InvalidImportEntriesModal, langText.InvalidImportEntriesDueTo)}}
            ({{errors.length}})
            {{localize(langSection.InvalidImportEntriesModal, langText.InvalidImportEntriesUsersWereNotImported)}}
        </p>
        <p>{{localize(langSection.InvalidImportEntriesModal, langText.InvalidImportEntriesNote)}}</p>
        <p>
            {{localize(langSection.InvalidImportEntriesModal, langText.InvalidImportEntriesTheseWere)}}
            ({{errors.length}})
            {{localize(langSection.InvalidImportEntriesModal, langText.InvalidImportEntriesErrorsFound)}}
        </p>
    </div>
    <div class="table-container">
        <table class="error-table" aria-label="Imported rows containing invalid entries">
            <thead>
                <tr>
                    <th scope="col"></th>
                    <th scope="col">{{localize(langSection.Term, langText.CountryCode)}}</th>
                    <th scope="col">{{localize(langSection.Term, langText.LocationCode)}}</th>
                    <th scope="col">{{localize(langSection.Term, langText.LocationSlic)}}</th>
                    <th scope="col">{{localize(langSection.Term, langText.UserId)}}</th>
                    <th scope="col">{{localize(langSection.Term, langText.Email)}}</th>
                    <th scope="col">{{localize(langSection.Term, langText.Role)}}</th>
                </tr>
            </thead>
            <tbody>
                @for (error of errors; track error) {
<tr>
                    <td>{{error.rowNumber}}</td>
                    <td class="{{error.countryCodeHasError ? 'error' : ''}}">{{error.countryCodeValue}}</td>
                    <td class="unchecked-field">{{error.slicName}}</td>
                    <td class="{{error.slicNumberHasError ? 'error' : ''}}">{{error.slicNumberValue}}</td>
                    <td class="{{error.upsIdHasError ? 'error' : ''}}">{{error.upsIdValue}}</td>
                    <td class="unchecked-field">{{error.email}}</td>
                    <td class="unchecked-field">{{roleToText(error.role)}}</td>
                </tr>
}
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer justify-content-center">
    <button class="btn btn-green" (click)="dismissModal()">
        {{localize(langSection.Term, langText.Continue)}}
    </button>
</div>
